import type {
	MainAppSetActiveArtistAction,
	MainAppSetClaimsAction,
	MainAppSetProfilesAction,
	MainAppSetUserAction,
	MainAppTokenAction,
	MyUser,
	Profile,
} from './types';
import {MainAppStateActionType} from './types';
import type {Claim} from '@deezer/next/services/api/Starmania/requests/claim/types';
import {onTokenUpdate, persistActiveArtist, persistUser} from './effects';
export const setUser = (user: MyUser | undefined): MainAppSetUserAction => {
	persistUser(user);
	return {
		type: MainAppStateActionType.SET_USER,
		user,
	};
};

export const setProfiles = (profiles: Profile[]): MainAppSetProfilesAction => {
	return {
		type: MainAppStateActionType.SET_PROFILES,
		profiles,
	};
};

export const setToken = (token: string): MainAppTokenAction => {
	onTokenUpdate(token);
	return {
		type: MainAppStateActionType.SET_TOKEN,
		value: token,
	};
};

export const setClaims = (claims: Claim[]): MainAppSetClaimsAction => {
	return {
		type: MainAppStateActionType.SET_CLAIMS,
		claims,
	};
};

export const setActiveArtist = (
	artistId: number | undefined,
): MainAppSetActiveArtistAction => {
	persistActiveArtist(artistId);
	return {
		type: MainAppStateActionType.SET_ACTIVE_ARTIST,
		artistId,
	};
};
